import React, { useEffect } from 'react'
import { Notice, NoticeLink } from './styles'

const BADGE_HIDDEN_CLASS = 'hide-recaptcha-badge'

// Google permite ocultar el sello de reCAPTCHA si se muestra este aviso en texto.
// El sello tapaba botones y textos en celulares.
function RecaptchaNotice({ compact }) {
  useEffect(() => {
    document.body.classList.add(BADGE_HIDDEN_CLASS)
    return () => document.body.classList.remove(BADGE_HIDDEN_CLASS)
  }, [])

  return (
    <Notice compact={compact}>
      Este sitio está protegido por reCAPTCHA y aplican la{' '}
      <NoticeLink href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
        Política de privacidad
      </NoticeLink>{' '}
      y los{' '}
      <NoticeLink href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">
        Términos del servicio
      </NoticeLink>{' '}
      de Google.
    </Notice>
  )
}

export { RecaptchaNotice }
